import {Component, input} from '@angular/core';
import {PhaseStatusView} from '@frontend/shared-api';
import {TenderProjectDescriptionButtonComponent} from './tender-project-description-button/tender-project-description-button.component';
import {TenderProviderResponseButtonComponent} from './tender-provider-response-button/tender-provider-response-button.component';
import {TenderReasonTextButtonComponent} from './tender-reason-text-button/tender-reason-text-button.component';

@Component({
  selector: 'app-tender-phase-action-buttons',
  imports: [
    TenderProjectDescriptionButtonComponent,
    TenderProviderResponseButtonComponent,
    TenderReasonTextButtonComponent,
  ],
  templateUrl: './tender-phase-action-buttons.component.html',
})
export class TenderPhaseActionButtonsComponent {
  readonly colorClass = input.required<string>();
  readonly phaseStatusInfo = input.required<PhaseStatusView>();
  readonly tenderId = input.required<number>();
}
